/* eslint-disable */
<template>
<div>
    <v-container class="my-0 pt-1 pb-0 px-0">
        <v-row no-gutters align-center justify-center v-if="loading" class="pl-2 ma-0">
            <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
        </v-row>
        <v-row no-gutters v-else class="flex-row align-baseline pa-0 ma-0" >
            <v-col v-if="show_action" cols="12" sm="12" md="3" class="d-flex align-start justify-end order-xs-1 order-sm-1 order-md-2 pb-0">
                <slot name="other_action"></slot>
                <v-btn
                    color="primary"
                    fab
                    small
                    v-can="{obj_type:'report', action: 'reopen'}"
                    v-if="reopenable"
                ><v-icon small @click.stop="reopenReport">lock_open</v-icon></v-btn>
                <span v-if="report_management">
                    <v-btn
                        color="primary"
                        fab
                        small
                        :disabled="$store.state.config.enable_report_code_gen && report.code.startsWith('tmp:')"
                    ><v-icon small @click.stop="editReportCode">edit_note</v-icon></v-btn>    
                    <v-btn
                        color="primary"
                        fab
                        small
                    ><v-icon small @click.stop="openDeleteConfirm">delete</v-icon></v-btn>    
                </span>
                <span v-else>
                    <span v-if="editable">
                        <v-btn
                            color="primary"
                            fab
                            small
                            v-report="{action: 'edit_owner', op_type: report.op_type, family: report.ext_data.instrument.family}"
                            v-if="isOwner"
                        ><v-icon small @click.stop="goToReportEdit">edit</v-icon></v-btn>
                        <v-btn
                            v-else
                            color="primary"
                            fab
                            small
                            v-report="{action: 'edit', op_type: report.op_type, family: report.ext_data.instrument.family}">
                        <v-icon small @click.stop="goToReportEdit">edit</v-icon></v-btn>
                    </span>
                    <v-btn
                        color="primary"
                        fab
                        small
                        v-report="{action: 'review', op_type: report.op_type, family: report.ext_data.instrument.family}"
                        v-if="!isOwner && revision"
                    ><v-icon small @click.stop="goToReportRevision">fact_check</v-icon></v-btn>
                    <v-btn
                        color="primary"
                        fab
                        small
                        v-report="{action: 'generate_xml', op_type: report.op_type, family: report.ext_data.instrument.family}"
                        v-if="xml_generation"
                    ><v-icon small @click.stop="goToReportXML">verified</v-icon></v-btn>
                    <v-btn
                        color="primary"
                        fab
                        small
                        v-report="{action: 'revising', op_type: report.op_type, family: report.ext_data.instrument.family}"
                        v-if="isOwner && revising"
                    ><v-icon small @click.stop="openRevisingDialog">rule</v-icon></v-btn>                
                    <span v-if="deletable">
                        <v-btn
                            v-if="isOwner"
                            color="primary"
                            fab
                            small
                            v-report="{action: 'remove_owner', op_type: report.op_type, family: report.ext_data.instrument.family}"
                        ><v-icon small @click.stop="openDeleteConfirm">delete</v-icon></v-btn>
                        <v-btn
                            v-else
                            color="primary"
                            fab
                            small
                            v-report="{action: 'remove', op_type: report.op_type, family: report.ext_data.instrument.family}"
                        ><v-icon small @click.stop="openDeleteConfirm">delete</v-icon></v-btn>
                    </span>
                </span>     
            </v-col>
            <v-col cols="12" sm="12" md="9" class="d-flex align-start justify-start order-xs-2 order-sm-2 order-md-1 pb-1  full-width">
                <slot name="ext_action"></slot>
                <div @click.stop="goToReportDetails" width="100%" class="d-flex flex-column full-width cursor_pointer">
                    <div class="d-flex align-center"><StatusIcon v-if="show_icon" class="small mr-2" :status="status" :tooltip_text="status_name"/>
                        <span class="d-flex align-baseline">{{op_types[report.op_type].prefix}} / <i>{{status_name}}</i> - {{report.code}}, <span class="caption"> del {{formatDate(report.report_date) }}</span></span></div>
                        <!-- <span class="d-flex align-baseline">{{op_types[report.op_type].prefix}} / <i>{{status_name}}</i> - {{report.code}}, <span class="caption"> del {{formatDate(report.report_date) }}, aggiornato il {{formatDate(report.updated)}} </span></span></div> -->
                    <div class="d-flex flex-row" v-if="show_instrument">
                        <span class="font-italic d-flex flex-grow-1 flex-shrink-0">
                            <b v-if="report.ext_data.instrument.name!=''">{{ report.ext_data.instrument.name }} / </b>
                            <b>{{ report.ext_data.instrument.serno}}</b> - <b>{{ report.ext_data.instrument.model }}</b> - <b>{{ report.ext_data.instrument.manufacturer}}</b></span>
                        <i class="d-flex flex-grow-0 flex-shrink-1">{{ families[report.ext_data.instrument.family].label }}</i>
                    </div>
                    <div class="d-flex flex-grow-1 flex-shrink-0" v-if="show_client_ext">
                        <div class="d-flex flex-column flex-grow-1 flex-shrink-0">
                            <div><b>{{ report.ext_data.client.name }}</b> - PIVA: {{ report.ext_data.client.piva }}</div>
                            <div>
                                {{ report.ext_data.location.name }} - {{ report.ext_data.location.address}} {{ report.ext_data.location.addrNum }},
                                {{ report.ext_data.location.city }} ({{ report.ext_data.location.district }})<br/>
                                <span v-if="report.ext_data.instrument.department_id">{{ report.ext_data.location.departments[report.ext_data.instrument.department_id].name }}</span></div>
                            <slot name="other_info"></slot>
                        </div>
                    </div>
                    <div class="d-flex full-width" v-if="show_client_short">
                        <div><b>{{ report.ext_data.client.name }}</b> - {{ report.ext_data.location.name }}</div>
                    </div>
                     <div>
                        <span class="font-italic">Eseguito da </span><span class="font-weight-bold">{{ $store.state.users[report.owner_id].name }}<br/></span>
                        <span class="d-flex align-center " v-if="report.reviewer">
                            <span class="font-italic">Revisionato da </span><b class="pl-1 pr-1">{{ $store.state.users[report.reviewer].name }}</b><span class="caption pr-2">il {{ report.review_date | formatDateTS }}</span><br/>
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>
    <ConfirmDialog
        v-bind:data="reopen_confirm"
        v-on:close_dialog="closeDialog"
        v-on:confirm_result="onReopenConfirm"/>
    
    <ConfirmDialog
        v-bind:data="delete_confirm"
        v-on:close_dialog="closeDialog"
        v-on:confirm_result="onDeleteConfirm"/>
    <BaseDialog
        :dialog="revisingDialog.open"
        v-on:close_dialog="closeRevisingDialog"
        >
        <template v-slot:title>
            Riesamina il report:
        </template>
        <div v-if="report">
            <v-row no-gutters>
                <v-col cols="12">
                    <span class="d-flex align-baseline">{{op_types[report.op_type].prefix}} / <i>{{status_name}}</i> - {{report.code}}, <span class="caption"> del {{formatDate(report.report_date) }}</span></span>
                    <!-- <span class="d-flex align-baseline">{{op_types[report.op_type].prefix}} / <i>{{status_name}}</i> - {{report.code}}, <span class="caption"> del {{formatDate(report.report_date) }}, aggiornato il {{formatDate(report.updated)}} </span></span> -->
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12"><b>{{ report.ext_data.client.name }}</b><br/>
                {{ report.ext_data.location.name }} - {{ report.ext_data.location.address}} {{ report.ext_data.location.addrNum }},
                {{ report.ext_data.location.city }} ({{ report.ext_data.location.district }})
                </v-col>
            </v-row>
            <div class="d-flex align-center justify-center">
                <span>
                    <v-btn class="ma-2" color="primary" @click.stop="editNewReport">Vai al report</v-btn>
                    <!--v-btn class="ma-2" color="primary" @click.stop="editNewOperation">crea un nuovo intervento</v-btn-->
                    <v-btn class="ma-2" text @click.stop="closeRevisingDialog">annulla</v-btn>
                </span>
            </div>        
        </div>
    </BaseDialog>

    <BaseDialog
        :dialog="editReportDialog.open"
        v-on:close_dialog="closeEditReportDialog"
        max_width="80%"
        >
        <template v-slot:title>
            Modifica report:
        </template>
        <div v-if="report">
           <v-row no-gutters>
                <v-col cols="12">
                    <span class="d-flex align-baseline">{{op_types[report.op_type].prefix}} / <i>{{status_name}}</i> - {{report.code}}, <span class="caption"> del {{formatDate(report.report_date) }}</span></span>
                    <!-- <span class="d-flex align-baseline">{{op_types[report.op_type].prefix}} / <i>{{status_name}}</i> - {{report.code}}, <span class="caption"> del {{formatDate(report.report_date) }}, aggiornato il {{formatDate(report.updated)}} </span></span> -->
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12"><b>{{ report.ext_data.client.name }}</b><br/>
                {{ report.ext_data.location.name }} - {{ report.ext_data.location.address}} {{ report.ext_data.location.addrNum }},
                {{ report.ext_data.location.city }} ({{ report.ext_data.location.district }})
                </v-col>
            </v-row>
            <v-divider />
            <v-row no-gutters>
                <v-col cols="12">
                    <span class="text-subtitle-1">codice report: <span class="font-italic font-weight-bold">{{report.code}}</span></span>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <span class="text-subtitle-1">nuovo codice report: 
                        <v-text-field dense outlined
                            class="pl-2"
                            label="codice"
                            v-model="editReportDialog.new_code"
                            :rules="[rules.mandatory]"
                        ></v-text-field></span>
                </v-col>
            </v-row>
            
             <div class="d-flex align-center justify-center">
                <span>
                    <v-btn class="ma-2" color="primary" @click.stop="saveReport">aggiorna il codice</v-btn>
                    <!--v-btn class="ma-2" color="primary" @click.stop="editNewOperation">crea un nuovo intervento</v-btn-->
                    <v-btn class="ma-2" text @click.stop="closeEditReportDialog">annulla</v-btn>
                </span>
            </div>        
        </div>
    </BaseDialog>    
    </v-container>
</div>
</template>
<script>
// import _ from 'lodash'

import {report_type, report_status_tooltip, i_families} from "../../utils/common.js"
import {f_rules, formatDatefromTS, getObjStatus} from "../../utils/commonUtils"
import BaseDialog from '../../components/dialogs/BaseDialog'
import { rStatusCanChange, getReportAllowedStatus, report_status_transition, isReopenable} from "../../utils/statusManagement"
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import StatusIcon from '../../components/utils/StatusIcon'

export default {
    components: {ConfirmDialog, StatusIcon, BaseDialog},
    props: {
        "report_id":{
            type: String,
            required: true
        }, 
        "show_instrument": {
            type: Boolean,
            required: false,
            default: false
        },
        "show_action": {
            type: Boolean,
            required: false,
            default: true
        },
        "show_icon": {
            type: Boolean,
            required: false,
            default: true
        },
        'show_client_ext':{
            type: Boolean,
            required: false,
            default: false
        },
        'show_client_short':{
            type: Boolean,
            required: false,
            default: false
        },
        'disable_link': {
            type: Boolean,
            required: false,
            default: false
        },
        'report_management':{
            type: Boolean,
            required: false,
            default: false
        }

    },
    data(){
        return {
            report: null,
            op_types: report_type,
            delete_confirm: {
                dialog: false,
                title: 'Elimina report',
                message: "Sei sicuro di voler rimuovere il report selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            reopen_confirm: {
                dialog: false,
                title: 'Riapri report',
                message: "Sei sicuro di voler riaprire il report selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "open_edit", val: "riapri e modifica"},
                    {key: "open", val: "riapri"}
                    ]
            },
            loading: true,
            allowedStatus: [],
            revisingDialog: {
                open: false
            },
            report_tooltip: report_status_tooltip,
            editReportDialog: {
                open: false,
                new_code: null
            },
            rules: f_rules,
            families: i_families
        }
    },
    mounted() {
        this.loadReport()
    },
    methods: {
        async loadReport() {
            this.loading = true
            this.report = await this.$store.state.$pouch.get('reports', this.report_id)
            this.allowedStatus = getReportAllowedStatus(this.report.op_type, this.report.status)
            this.loading = false
            //this.operation = await this.$store.state.$pouch.get('operations', this.report.op_id)
        },
        reopenReport(){
            this.reopen_confirm.dialog = true;
        },

        //inutilizzato, abilitare se il report deve essere visibile al tecnico
        async fixOperationSync(){
            console.log("$$$$ report", this.report.operation_id)
            let op = await this.$store.state.$pouch.get('operations', this.report.operation_id);
            console.log("$$$$ operation", op)
            if(!op.sync){
                let selector = {
                    "$or" : [
                        {"_id" : {"$in": [op.client_id, op.partner_id, ...op.instrument_ids]}
                        },
                        
                        {doc_type: "location" , client_id: {'$in': [op.client_id, op.partner_id]}
                        }
                ]}
                console.log("$$$ selector new", JSON.stringify(selector))
                let registry = await this.$store.state.$pouch.find('registry', {selector:selector})
                console.log("$$$$ trovati", registry.docs)
                await this.$store.state.$pouch.bulkDocs('registry', registry.docs)
                op.sync = true
                await this.$store.state.$pouch.put('operations', op)
                console.log("$$$$ finito metodo")
            }
        },

        async onReopenConfirm(choice) {
            try {
                if (choice != 'cancel'){
                    this.report.status = "measuring"
                    this.report.report_pdf_path = ""
                    this.report.signed_path = ""
                    this.report.certificate_path = ""
                    this.report.updated = (new Date()).getTime()
                    this.report.updated_by = this.$store.state.user._id
                    await this.$store.state.$pouch.put('reports', this.report)
                    // await this.fixOperationSync()
                }
                this.closeDialog()
                if (choice == 'open_edit') {
                    this.$router.push({path: "/reports/edit", query: {"report_id": this.report._id, "back": this.$router.history.current.fullPath}})
                }
            } catch(error) {
                console.log('error', error)
            }
        },
        editReportCode() {
            this.editReportDialog.open = true
        },
        closeEditReportDialog(){
            this.editReportDialog.open = false
        },
        openDeleteConfirm(){
            this.delete_confirm.dialog = true;
        },
        async saveReport() {
            try {
                let report = {...this.report}
                report.code = this.editReportDialog.new_code
                let res = await this.$store.state.$pouch.put('reports', report)
                console.log('RES', res)
                this.report._rev = res.rev
                this.report.code = this.editReportDialog.new_code
                this.closeEditReportDialog()
                this.$store.commit("showSnackbar", {text: "Report aggiornato", color: 'primary'})
            } catch(error) {
                console.log('error', error)
            }
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    if (rStatusCanChange(this.report.op_type, this.report.status, 'deleted')) {
                        this.report.status = 'deleted'
                        this.report.updated = (new Date()).getTime()
                        this.report.updated_by = this.$store.state.user._id
                
                        let res = await this.$store.state.$pouch.put('reports', this.report)
                        if (res.ok) {
                            this.$emit('report_removed',this.report_id, this.report.instrument_id)
                        }
                    }
                }
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
            this.reopen_confirm.dialog = false
        },
        goToReportEdit() {
            if (this.disable_link) {
                return
            }
            this.$router.push({path: "/reports/edit", query: {"report_id": this.report._id, "back": this.$router.history.current.fullPath}}) 
        },
        goToReportRevision() {
            if (this.disable_link) {
                return
            }
            this.$router.push({path: "/reports/review", query: {"report_id": this.report._id, "back": this.$router.history.current.fullPath}}) 
        },
        goToReportDetails() {
            if (this.disable_link) {
                return
            }
            this.$router.push({path: "/reports/details", query: {"report_id": this.report._id, "back": this.$router.history.current.fullPath}}) 
        },
        goToReportSign() {

        },
        formatDate(ts) {
            return formatDatefromTS(ts)
        },
        openRevisingDialog() {
            this.revisingDialog.open = true
        },
        closeRevisingDialog() {
            this.revisingDialog.open = false
        },
        async editNewReport() {
            let parts = this.report._id.split('_')
            let version = 1
            if (parts.length == 2) {
                let i = parseInt(parts[1])
                version = i+1
            } 
            let new_id = parts[0]+'_'+version
            this.updated = (new Date()).getTime()
            let new_report = _.cloneDeep(this.report)
            new_report._id = new_id
            new_report.status = "measuring"
            new_report.updated_by = this.$store.state.user._id
            if (!new_report.history) {
                new_report.history = []
            }
            new_report.history.push({
                'prev_report': this.report._id,
                'rev': version,
                'report_date': this.report.report_date,
                'review_date': this.report.review_date,
                'remarks': this.report.remarks,
                'review_remarks':this.report.review_remarks})
            delete(new_report._rev)
            delete(new_report.report_date)
            delete(new_report.remarks)
            delete(new_report.review_date)
            delete(new_report.review_remarks)
            this.report.status = "revised"
            try {
                let res = await this.$store.state.$pouch.bulkDocs('reports', [this.report, new_report])
                if (res[0].ok && res[1].ok) {
                    this.closeRevisingDialog()
                    this.$router.push({path: "/reports/edit", query: {"report_id": new_report._id, "back": this.$router.history.current.fullPath}})
                } else {
                    this.closeRevisingDialog()
                    this.$store.commit("showSnackbar", {text: "Problemi con il salvataggio", color: 'error'})
                }
            } catch(error) {
                console.log('error', error)
            }
        },
        editNewOperation() {
            
        }
    },
    computed: {
        isOwner() {
            return this.report.owner_id == this.$store.state.user._id
        },
        deletable() {
            //if (!this.allowedStatus) return false
            // console.log("DELETABLE", this.report._id, this.report.status)
            if (this.$store.state.config.enable_report_code_gen && this.report.status != 'new' && this.report.status != 'measuring') {
                // console.log("DELETABLE FALSE", this.report._id, this.report.status)
                return false
            }
            // console.log("DELETABLE verified CODE GEN", this.$store.state.config.enable_report_code_gen, this.report.status)
            return this.allowedStatus.includes('deleted') && (!this.report.history || this.report.history.length==0)
        },
        editable() {
            //if (!this.allowedStatus) return false
            
            return this.allowedStatus.includes('measuring')
        },
        reopenable () {
            return isReopenable(this.report.status)
        },
        revision() {
            //if (!this.allowedStatus) return false
            return this.allowedStatus.includes('reviewed')
        },
        revising() {
            return this.report.status == 'revising'
        },
        xml_generation() {
            return false
        },
        sign() {
            return false
        },
        status() {
            if (this.report) {
                let status = getObjStatus(this.$store.state.config.threshold, this.report, null)
                return status
            }
            return ''
        },
        status_name() {
            return report_status_transition[this.report.op_type][this.report.status].name
        }
    }
    
}

</script>
